/**
 * Where a merchant lands once their Shopify store is attached.
 *
 * A merchant still inside the onboarding wizard goes back to it with the
 * store marked connected (the wizard advances by itself); everyone else goes
 * to Integrations with the success toast. Before this, a signed-in merchant
 * who installed from the App Store during onboarding landed on Integrations
 * and the onboarding gate bounced them to step 0 with no sign the store had
 * connected.
 */
export interface BrandLookup {
  (): Promise<{ data?: { onboardingCompleted?: boolean } | null } | null>;
}

export const SHOPIFY_CONNECTED_ONBOARDING = '/onboarding?platform=shopify&success=true';
export const SHOPIFY_CONNECTED_INTEGRATIONS = '/account?tab=integrations&shopify=success';

export async function shopifyConnectedDestination(getBrand: BrandLookup): Promise<string> {
  try {
    const res = await getBrand();
    if (res?.data && res.data.onboardingCompleted === false) return SHOPIFY_CONNECTED_ONBOARDING;
  } catch {
    // The brand lookup failing must not strand the merchant: Integrations is
    // always a valid place to land.
  }
  return SHOPIFY_CONNECTED_INTEGRATIONS;
}
